import { SafelyResource } from "../../SafelyResource";

type DetailPairIdOptions = {
    id: string | number;
    routeId: string | number;
    resource: SafelyResource;
    route: string;
}

export class DetailPair {
    displayText!: string;
    value: any;
    helpText?: string;
    idOptions?: DetailPairIdOptions | null;
    isLink?: boolean;

    constructor(
        text: string, 
        value: any, 
        helpText?: string, 
        idOptions?: DetailPairIdOptions | null,
        isLink?: boolean
    ) {
        this.displayText = text;
        this.value = value;
        this.helpText = helpText;
        this.idOptions = idOptions;
        this.isLink = isLink;
    }
}